import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'completo' | 'base'>('completo');
  return <section className="py-16 bg-brand-dark relative border-t border-zinc-900" id="pricing" data-id="element-175">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-176">
        <FadeIn data-id="element-177">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 text-center uppercase tracking-tight" data-id="element-178">
            ELEGÍ TU OPCIÓN
          </h2>
          <p className="text-xl text-zinc-400 text-center mb-10" data-id="element-179">
            Seleccioná el pack que mejor se adapte a tu objetivo.
          </p>
        </FadeIn>

        {/* Radio-select pricing cards */}
        <FadeIn delay={0.1} data-id="element-180">
          <div className="max-w-2xl mx-auto space-y-4 mb-8" data-id="element-181">
            {/* MASTER PACK COMPLETO — Option 1 */}
            <button type="button" onClick={() => setSelected('completo')} className={`w-full text-left rounded-2xl p-5 md:p-6 transition-all duration-300 cursor-pointer border-2 ${selected === 'completo' ? 'border-[#5DF300] bg-zinc-900/90 shadow-[0_0_25px_rgba(93,243,0,0.12)]' : 'border-zinc-800 bg-zinc-900/40 hover:border-zinc-700'}`} data-id="element-182">
              <div className="flex items-start gap-4" data-id="element-183">
                {/* Radio indicator */}
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selected === 'completo' ? 'border-[#5DF300]' : 'border-zinc-600'}`} data-id="element-184">
                  {selected === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-[#5DF300]" data-id="element-185"></div>}
                </div>

                {/* Content */}
                <div className="flex-grow min-w-0" data-id="element-186">
                  <div className="flex items-start justify-between gap-4 flex-wrap" data-id="element-187">
                    <div data-id="element-188">
                      <div className="flex items-center gap-2 mb-2" data-id="element-189">
                        <span className="text-xl" data-id="element-190">🏆</span>
                        <h3 className="text-xl md:text-2xl font-bold text-white uppercase" data-id="element-191">
                          MASTER PACK COMPLETO
                        </h3>
                      </div>
                      <div className="flex flex-wrap gap-2 mb-3" data-id="element-192">
                        <span className="text-white text-xs font-bold px-2.5 py-1 rounded-full uppercase tracking-wider bg-[#F38300]" data-id="element-193">
                          MÁS ELEGIDO
                        </span>
                        <span className="text-zinc-950 text-xs font-bold px-2.5 py-1 rounded-full uppercase tracking-wider bg-[#5DF300]" data-id="element-194">
                          AHORRÁS $7.000
                        </span>
                      </div>
                    </div>
                    <div className="text-right shrink-0" data-id="element-195">
                      <p className="text-zinc-500 line-through text-sm" data-id="element-196">
                        $36.990
                      </p>
                      <p className="text-3xl md:text-4xl font-bold text-[#5DF300]" data-id="element-197">
                        $29.990
                      </p>
                    </div>
                  </div>

                  <p className="text-zinc-300 text-sm font-medium" data-id="element-198">
                    5 tomos + 2 bonos
                  </p>
                  <p className="text-brand-amber font-bold text-sm mt-1" data-id="element-199">
                    + Mantenimiento Preventivo Express
                  </p>
                  <ul className="text-zinc-400 text-xs mt-1.5 space-y-0.5" data-id="element-200">
                    <li data-id="element-201">- Rutina Semanal de 15 Minutos</li>
                    <li data-id="element-202">- Directorio de Repuestos Argentina</li>
                  </ul>
                </div>
              </div>
            </button>

            {/* PACK BASE — Option 2 */}
            <button type="button" onClick={() => setSelected('base')} className={`w-full text-left rounded-2xl p-5 md:p-6 transition-all duration-300 cursor-pointer border-2 ${selected === 'base' ? 'border-[#5DF300] bg-zinc-900/90 shadow-[0_0_25px_rgba(93,243,0,0.12)]' : 'border-zinc-800 bg-zinc-900/40 hover:border-zinc-700'}`} data-id="element-203">
              <div className="flex items-start gap-4" data-id="element-204">
                {/* Radio indicator */}
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selected === 'base' ? 'border-[#5DF300]' : 'border-zinc-600'}`} data-id="element-205">
                  {selected === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-[#5DF300]" data-id="element-206"></div>}
                </div>

                {/* Content */}
                <div className="flex-grow min-w-0" data-id="element-207">
                  <div className="flex items-start justify-between gap-4 flex-wrap" data-id="element-208">
                    <div data-id="element-209">
                      <div className="flex items-center gap-2 mb-1" data-id="element-210">
                        <span className="text-xl" data-id="element-211">💚</span>
                        <h3 className="text-xl md:text-2xl font-bold text-white uppercase" data-id="element-212">
                          PACK BASE
                        </h3>
                      </div>
                    </div>
                    <div className="text-right shrink-0" data-id="element-213">
                      <p className="text-zinc-500 line-through text-sm" data-id="element-214">
                        $26.990
                      </p>
                      <p className="text-3xl md:text-4xl font-bold text-white" data-id="element-215">
                        $19.990
                      </p>
                    </div>
                  </div>
                  <p className="text-zinc-400 text-sm font-medium" data-id="element-216">
                    5 tomos + 2 bonos
                  </p>
                </div>
              </div>
            </button>
          </div>

          {/* Single CTA Button */}
          <div className="max-w-2xl mx-auto mb-12" data-id="element-217">
            <a href={selected === 'completo' ? 'https://fegion.shop/cart/46210825814155:1' : 'https://fegion.shop/cart/46210815328395:1'} className="w-full block text-center py-5 px-6 bg-[#5DF300] hover:bg-[#4CD200] text-zinc-950 font-bold rounded-2xl transition-colors uppercase tracking-wide text-lg shadow-[0_0_30px_rgba(93,243,0,0.3)]" data-id="element-218">
              🛡️ EMPEZAR HOY — {selected === 'completo' ? '$29.990' : '$19.990'}
            </a>
            <p className="text-center text-sm text-zinc-500 mt-3" data-id="element-219">
              ✅ Acceso inmediato · ✅ 100% Digital · ✅ Garantía 7 días
            </p>
          </div>
        </FadeIn>

        {/* Feature Comparison Table */}
        <FadeIn delay={0.2} data-id="element-220">
          <div className="max-w-4xl mx-auto bg-zinc-900/50 border border-zinc-800 rounded-2xl overflow-hidden" data-id="element-221">
            <div className="grid grid-cols-12 border-b border-zinc-800 bg-zinc-900 p-4" data-id="element-222">
              <div className="col-span-6 md:col-span-8 font-bold text-zinc-400 uppercase text-sm" data-id="element-223">
                Características
              </div>
              <div className="col-span-3 md:col-span-2 text-center font-bold text-white text-sm" data-id="element-224">
                BASE
              </div>
              <div className="col-span-3 md:col-span-2 text-center font-bold text-[#5DF300] text-sm" data-id="element-225">
                COMPLETO
              </div>
            </div>

            <div className="divide-y divide-zinc-800/50" data-id="element-226">
              <div className="grid grid-cols-12 p-3 md:p-4 items-center" data-id="element-227">
                <div className="col-span-6 md:col-span-8 text-zinc-300 text-sm" data-id="element-228">
                  5 Tomos Reparación Express
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-229">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-230" />
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-231">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-232" />
                </div>
              </div>
              <div className="grid grid-cols-12 p-3 md:p-4 items-center" data-id="element-233">
                <div className="col-span-6 md:col-span-8 text-zinc-300 text-sm" data-id="element-234">
                  Bono 1: Kit Rescate en la Calle
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-235">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-236" />
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-237">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-238" />
                </div>
              </div>
              <div className="grid grid-cols-12 p-3 md:p-4 items-center" data-id="element-239">
                <div className="col-span-6 md:col-span-8 text-zinc-300 text-sm" data-id="element-240">
                  Bono 2: Herramientas Cero + Setup
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-241">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-242" />
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-243">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-244" />
                </div>
              </div>
              <div className="grid grid-cols-12 p-3 md:p-4 items-center bg-brand-amber/5" data-id="element-245">
                <div className="col-span-6 md:col-span-8 text-brand-amber font-medium text-sm" data-id="element-246">
                  Rutina Semanal de 15 Minutos
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-247">
                  <XIcon className="w-5 h-5 text-zinc-600" data-id="element-248" />
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-249">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-250" />
                </div>
              </div>
              <div className="grid grid-cols-12 p-3 md:p-4 items-center bg-brand-amber/5" data-id="element-251">
                <div className="col-span-6 md:col-span-8 text-brand-amber font-medium text-sm" data-id="element-252">
                  Directorio de Repuestos Argentina
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-253">
                  <XIcon className="w-5 h-5 text-zinc-600" data-id="element-254" />
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-255">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-256" />
                </div>
              </div>
              <div className="grid grid-cols-12 p-3 md:p-4 items-center bg-brand-amber/5" data-id="element-257">
                <div className="col-span-6 md:col-span-8 text-brand-amber font-medium text-sm" data-id="element-258">
                  Agenda de Mantenimiento 12 Meses
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-259">
                  <XIcon className="w-5 h-5 text-zinc-600" data-id="element-260" />
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-261">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-262" />
                </div>
              </div>
              <div className="grid grid-cols-12 p-3 md:p-4 items-center bg-brand-amber/5" data-id="element-263">
                <div className="col-span-6 md:col-span-8 text-brand-amber font-medium text-sm" data-id="element-264">
                  Alertas Estacionales (invierno/verano)
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-265">
                  <XIcon className="w-5 h-5 text-zinc-600" data-id="element-266" />
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-267">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-268" />
                </div>
              </div>
              <div className="grid grid-cols-12 p-3 md:p-4 items-center bg-brand-amber/5" data-id="element-269">
                <div className="col-span-6 md:col-span-8 text-brand-amber font-medium text-sm" data-id="element-270">
                  Log de Reparaciones y Km
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-271">
                  <XIcon className="w-5 h-5 text-zinc-600" data-id="element-272" />
                </div>
                <div className="col-span-3 md:col-span-2 flex justify-center" data-id="element-273">
                  <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-274" />
                </div>
              </div>
              <div className="grid grid-cols-12 p-3 md:p-4 items-center bg-zinc-900 border-t border-zinc-800" data-id="element-275">
                <div className="col-span-6 md:col-span-8 font-bold text-white text-right pr-4 uppercase text-sm" data-id="element-276">
                  PRECIO
                </div>
                <div className="col-span-3 md:col-span-2 text-center font-bold text-zinc-400" data-id="element-277">
                  $19.990
                </div>
                <div className="col-span-3 md:col-span-2 text-center font-bold text-[#5DF300] text-lg" data-id="element-278">
                  $29.990
                </div>
              </div>
            </div>
          </div>

          <div className="max-w-2xl mx-auto mt-6 bg-zinc-900/80 border border-brand-amber/30 p-5 rounded-xl text-center" data-id="element-279">
            <p className="text-lg font-bold text-white mb-1" data-id="element-280">
              💡 Solo $10.000 ARS más.
            </p>
            <p className="text-zinc-400 text-sm mb-1" data-id="element-281">
              El Mantenimiento Preventivo Express por separado vale $16.970 ARS.
            </p>
            <p className="text-brand-amber font-bold text-sm" data-id="element-282">
              Agregándolo ahora lo llevás con un descuento del 40%!!!
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}